import { createTheme } from '@material-ui/core';

export const theme = createTheme({
    overrides: {
        MuiStepConnector: {
            root: {
                '&$alternativeLabel': {
                    top: "15px",
                    left: "calc(-50% + 30px)",
                    right: "calc(50% + 30px)"
                },
                '&$active': {
                    color: "var(--itsm-bg-btn)",
                },
                '&$completed': {
                    color: "var(--itsm-bg-btn)",
                },
            }
        },
        MuiStepIcon: {
            root: {
                fontSize: "30px",
                '&$active': {
                    color: "var(--itsm-bg-btn)",
                },
                '&$completed': {
                    color: "var(--itsm-bg-btn)",
                },
            },
        },
        MuiInputLabel: {
            root: {
                '&$focused': {
                    color: "var(--itsm-bg-btn)",
                    "&.MuiSvgIcon-root": {
                        color: "#888888",
                    },
                },
            },
        },
        MuiOutlinedInput: {
            root: {
                "&.MuiInputBase-root fieldset": {
                    border: '1px solid #888888'
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "var(--itsm-bg-btn)",
                }
            },

        },
        MuiButton:{
            root: {
                "&.btn-next": {
                    backgroundColor: "var(--itsm-bg-btn)",
                    color: "#fff"
                },
                "&.btn-next:hover": {
                    backgroundColor: "var(--itsm-bg-btn)",
                    
                },
                padding: "8px 16px",
            },
            label: {
                fontSize: "13px",
                textTransform: "capitalize"
            },
        },
        // MuiSvgIcon: {
        //     root: {
        //         color: "var(--default-color)",
        //     }
        // },
        MuiFormControlLabel:{
            label:{
                fontSize: "13px"
            }
        },
        MuiCheckbox:{
            root: {
                color: "var(--itsm-bg-btn)",
                "&$checked": {
                    color: "var(--itsm-bg-btn)  !important",
                },
                "&:hover": {
                    backgroundColor: "#00dc4414 !important"
                }
            }
        },
        MuiCircularProgress:{
            svg:{
                color: "var(--itsm-bg-btn)",
            }
        },
        MuiFormLabel: {
            root: {
                color: "#888888",
            }
        },
        MTableToolbar: {
            root: {
                borderRadius: "20px"
            }
        }
    },
});

//Change all color from 6FB554 to 00917c var(--itsm-bg-btn)